export default "__VITE_ASSET__a57ea410__"